module.exports = __webpack_public_path__ + "media/src/images/icon/event-lg-af263fd0c750faab4fc6ae2234e2e2b3.png";